<template>
  <div class="footer-bar">
    <template v-if="isScenePlaying || isSceneFinished">
      <div class="footer-bar-wrap" v-show="!isShowAnswerCard">
        <p class="tip">
          <template v-if="isExam">
            点击“Enter”键进入下一题，点击“检查”查看答题卡快速跳转至某题或交卷
            <template v-if="isTHXZ">
              , <span class="danger">点击右上角音频按钮开始答题</span>
            </template>
          </template>
          <template v-else-if="isZSD">点击“Enter”键查看下一个知识点。</template>
          <template v-else>点击“Enter”键继续。</template>
        </p>
        <div class="icons">
          <span class="btn btn-blue-circle prev"
            :class="{ disabled: isFirst }"
            v-if="isExam"
            @click="$emit('prev')">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/02cb3a080cba49e6788f885c7e6e8d24.png" alt="">
          </span>
          <span class="btn btn-blue-square" v-if="isExam" @click="$emit('detail')">检查</span>
          <van-speaker
            class="circle primary-u"
            v-if="isShowSpeaker"
            ref="speaker"
            :src="currentExercise.audio"
            @speak="speak" />
          <i
            class="iconfont icon-eraser"
            @click="clear"
            v-if="isShowEraser"></i>
          <span class="btn btn-blue-circle"
            :class="{ disabled: (isLast && this.isExam) || (!this.isExam && !isAnswered) }"
            @click="$emit('next')">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/02cb3a080cba49e6788f885c7e6e8d24.png" alt="">
          </span>
        </div>
      </div>
      <div class="footer-bar-wrap" v-show="isShowAnswerCard && isExam && !isSceneFinished ">
        <p class="tip">
          点击<strong> 交卷 </strong>可提交并计算成绩。
        </p>
        <div class="button-wrap">
          <el-button class="btn btn-blue-square" @click="submitExam">交卷</el-button>
        </div>
      </div>
      <div class="footer-bar-wrap"
        v-show="isShowAnswerCard && isExam && isSceneFinished && isShowBottomControl">
        <div class="button-wrap exam-finished">
          <slot name="foot"></slot>
          <el-button
            class="btn btn-orange-square"
            v-if="isShowReplay"
            :disabled="isDisabledReplay"
            @click="replay">错题再练</el-button>
          <el-button
            class="btn btn-blue-square"
            @click="finished">{{finishedText}}</el-button>
        </div>
      </div>
    </template>
    <template v-else-if="isSceneExamList || isSceneComparison">
      <div class="footer-bar-wrap" v-show="!isShowAnswerCard">
        <p class="tip" v-show="isShowTip">
          <template v-if="!isExamRecords">
            本次考试共答错 {{wrongNumber}} 题
          </template>
          <template v-if="!(type === 'fallible' || type === 'drill')">
            ，错题将自动进入"错题本"，可随时复习。
          </template>
        </p>
        <div class="button-wrap">
          <div
            class="btn btn-orange-square"
            v-if="!isExamRecords"
            @click="toggleCheckType"
            >{{ isCheckAll ? '仅看错题' : '全部' }}</div>
          <div
            class="btn btn-blue-square"
            @click="back">返回</div>
        </div>
      </div>
    </template>
    <exam-confirm-dialog
      @cancel="cancel"
      @confirm="confirm"
      ref="exam-confirm" />
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';
import ExamConfirmDialog from '@/components/quizzes/ExamConfirmDialog.vue';
import Speaker from 'vanthink-components/components/common/Speaker.vue';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
  examList: 4,
  comparison: 5,
});

export default {
  components: {
    VanSpeaker: Speaker,
    ExamConfirmDialog,
  },
  props: {
    currentExercise: {
      type: Object,
      default: () => ({}),
    },
    isExamRecords: {
      type: Boolean,
      default: false,
    },
    isShowBottomControl: {
      type: Boolean,
      default: false,
    },
    isDisabledReplay: {
      type: Boolean,
      default: false,
    },
    isShowReplay: {
      type: Boolean,
      default: true,
    },
    finishedText: {
      type: String,
      default: '下一步',
    },
    isShowSpeaker: {
      type: Boolean,
      default: false,
    },
    isShowEraser: {
      type: Boolean,
      default: false,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    current: {
      type: Number,
      default: 0,
    },
    results: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    scene: {
      type: Number,
      require: true,
    },
    isShowAnswerCard: {
      type: Boolean,
      default: false,
    },
    isShowTip: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    currentExercise: {
      handler() {
        if (this.isShowSpeaker) {
          this.$nextTick(() => {
            if (this.$refs.speaker) {
              this.$refs.speaker.initPlay();
            }
          });
        }
      },
      immediate: true,
    },
    scene() {
      if (this.scene === 2) {
        this.$nextTick(() => {
          if (this.$refs.speaker) {
            this.$refs.speaker.initPlay();
          }
        });
      }
    },
  },
  computed: {
    isZSD() {
      return this.currentExercise.code === 'ZSD';
    },
    isDX() {
      return this.currentExercise.code === 'DX';
    },
    isTHXZ() {
      return this.currentExercise.code === 'THXZ';
    },
    isFirst() {
      return this.current <= 0;
    },
    isLast() {
      return this.current >= this.total - 1;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    isSceneFinished() {
      return this.scene === SCENE.finished;
    },
    isSceneExamList() {
      return this.scene === SCENE.examList;
    },
    isSceneComparison() {
      return this.scene === SCENE.comparison;
    },
    wrongNumber() {
      return this.results.filter(item => !item.isRight).length;
    },
    isAnswered() {
      if (this.isDX) {
        return this.currentExercise.isComplete;
      }
      return true;
    },
  },
  data() {
    return {
      isCheckAll: true,
    };
  },
  methods: {
    toggleCheckType() {
      this.isCheckAll = !this.isCheckAll;
      this.$emit('toggleCheckType', this.isCheckAll);
    },
    back() {
      this.isCheckAll = true;
      this.$emit('toggleCheckType', this.isCheckAll);
      this.$emit('back');
    },
    submitExam() {
      this.$refs['exam-confirm'].open();
    },
    cancel() {
      this.$refs['exam-confirm'].close();
    },
    confirm() {
      this.$emit('submit');
      this.$refs['exam-confirm'].close();
    },
    clear() {
      this.$emit('clear');
    },
    replay() {
      this.$emit('replay');
    },
    finished() {
      this.$emit('finished');
    },
    speak() {
      this.$emit('speak');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .footer-bar {
    .footer-bar-wrap {
      position: relative;
      display: flex;
      align-items: center;
      height: 45px;
      .tip {
        flex: 1;
        text-align: left;
        margin: 0;
        color: $grey-color;
        height: 45px;
        font-size: 16px;
        line-height: 45px;
        strong {
          margin: 0 2px;
          padding: 2px;
          color: #fff;
          background: $primary;
          border-radius: 3px 4px;
        }
      }
      .danger {
        color: $danger;
      }
      .button-wrap {
        display: flex;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        .btn {
          margin-left: 10px;
        }
      }
      .exam-finished {
        .el-button {
          margin-right: 10px;
        }
      }
      .icons {
        position: absolute;
        right: 0;
        display: flex;
        align-items: center;
        cursor: pointer;
        .btn {
          margin-left: 30px;
        }
        .prev {
          img {
            transform: rotate(-180deg);
          }
        }
        .button {
          box-sizing: border-box;
          display: inline-block;
          margin-left: 30px;
          width: 45px;
          height: 45px;
          color: #fff;
          font-size: 18px;
          line-height: 45px;
          text-align: center;
          vertical-align: middle;
          background: $primary;
          border-radius: 50%;
          &:hover {
            opacity: .8;
          }
        }
        i {
          font-size: 48px;
          color: $primary;
          margin-left: 30px;
          vertical-align: middle;
          &.disabled {
            color: rgba($grey-color, .2);
            cursor: not-allowed;
            &:active {
              color: rgba($grey-color, .3);
            }
          }
          &:active {
            color: $primary-light;
          }
        }
        /deep/ .speaker {
          width: 43px;
          height: 43px;
          svg {
            width: 27px;
            height: 30px;
            line-height: 30px;
          }
        }
        .icon-eraser {
          border-radius: 50%;
          color: #fff;
          font-size: 42px;
          line-height: 42px;
          background-color: $primary;
        }
      }
    }
  }
</style>
